import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

export default function ReportProgress() {
    const [isActivetab, setActivetab] = useState('div1')
    
      const handleActivetoggle = (tab) => {
        setActivetab(tab)
      }

    return (
        <div>
            <h1 className='text-[#fff] text-xl font-bold text-center'>Minting in Progress</h1>
            <p className='text-white text-center text-sm mt-4'>Your DNA analysis process has been initiated. Please check your email regularly for updates. Once your report is generated, your passport will be created accordingly.</p>
            <div className='flex flex-col md:flex-row gap-10 items-center mt-5'>
                <div className='w-[100%] lg:w-[50%] 2xl:text-lg space-y-5'>
                    <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                                    ${isActivetab === 'div1' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                        onClick={() => handleActivetoggle('div1')}>
                        <p className='flex items-center gap-5'><span>01</span> Muscular System</p>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                    <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                                    ${isActivetab === 'div2' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                        onClick={() => handleActivetoggle('div2')}>
                        <p className='flex items-center gap-5'><span>02</span> Psychiatrics</p>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                    <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                                    ${isActivetab === 'div3' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                        onClick={() => handleActivetoggle('div3')}>
                        <p className='flex items-center gap-5'><span>03</span> Sports</p>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                    <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                                    ${isActivetab === 'div4' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                        onClick={() => handleActivetoggle('div4')}>
                        <p className='flex items-center gap-5'><span>04</span> Injuries</p>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                    <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                                    ${isActivetab === 'div5' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                        onClick={() => handleActivetoggle('div5')}>
                        <p className='flex items-center gap-5'><span>05</span> Behavior</p>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </div>
                <div className='w-[100%] lg:w-[50%]'>
                    {isActivetab === 'div1' && (
                        <div><img src='/assets/map/chart1.svg' className='mx-auto'></img></div>
                    )}
                    {isActivetab === 'div2' && (
                        <div><img src='/assets/map/chart2.svg' className='mx-auto'></img></div>
                    )}
                    {isActivetab === 'div3' && (
                        <div><img src='/assets/map/chart3.svg' className='mx-auto'></img></div>
                    )}
                    {isActivetab === 'div4' && (
                        <div><img src='/assets/map/chart4.svg' className='mx-auto'></img></div>
                    )}
                    {isActivetab === 'div5' && (
                        <div><img src='/assets/map/chart5.svg' className='mx-auto'></img></div>
                    )}
                </div>
            </div>
        </div>
    )
}
